import React from "react";
import { Col, Row } from "react-bootstrap";
import team1 from "../Images/executiveBody/team1.jpg";
import team2 from "../Images/executiveBody/Adv. Ajay Bist.jpg";
import team3 from "../Images/executiveBody/Vinod Sagar (Vice President).jpg";
import team4 from "../Images/executiveBody/team4.jpg";
import team5 from "../Images/executiveBody/team5.jpg";
import team6 from "../Images/executiveBody/team6.jpg";
import team7 from "../Images/executiveBody/team7.jpg";
import team8 from "../Images/executiveBody/team8.jpg";
import team9 from "../Images/executiveBody/team9.jpg";
import team10 from "../Images/executiveBody/team10.jpg";
import team11 from "../Images/executiveBody/Rajeev Kumar Rohilla (Treasurer).jpg";
import president from "../Images/executiveBody/president.png";
import VPFemale from "../Images/executiveBody/VicePresidentFemale.png";
import JointSecretary from "../Images/executiveBody/JointSecretary.png";
import AradhnaChaturvedi from "../Images/executiveBody/AradhnaChaturvedi.png";
import AvishkarRawat from "../Images/executiveBody/AvishkarRawat.png";
import RamanSharma from "../Images/executiveBody/RamanSharma.png";

const ExecutiveBody = () => {
  return (
    <>
      <section className="p-5 mx-md-5">
        <h1>Executive Body</h1>
        <Row className="mt-5">
          <Col md={3} sm={12}>
            <div class="card">
              <img src={president} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">Adv. Manmohan Kandwal</h6>
                <h6 class="card-subtitle mb-2 text-muted">President</h6>
              </div>
            </div>
          </Col>
          <Col md={3} sm={12}>
            <div class="card">
              <img src={team2} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">Adv. Ajay Bist</h6>
                <h6 class="card-subtitle mb-2 text-muted">Secretary</h6>
              </div>
            </div>
          </Col>
          <Col md={3} sm={12}>
            <div class="card">
              <img src={team3} class="card-img-top" alt="..." />
              <div class="card-body g-0">
                <h6 class="card-title text-danger text-center">
                  Adv. Vinod Sagar
                </h6>
                <h6 class="card-subtitle mb-2 text-muted text-center">
                  Vice President
                </h6>
              </div>
            </div>
          </Col>
          <Col md={3} sm={12}>
            <div class="card">
              <img src={VPFemale} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">Adv. Seema Chaddha</h6>
                <h6 class="card-subtitle mb-2 text-muted">
                  Vice-President(Female)
                </h6>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={3} sm={12}>
            <div class="card">
              <img src={JointSecretary} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">Adv. Kapil Arora</h6>
                <h6 class="card-subtitle mb-2 text-muted">Joint Secretary</h6>
              </div>
            </div>
          </Col>
          <Col md={3} sm={12}>
            <div class="card">
              <img src={team11} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">
                  Adv. Rajeev Kumar Rohilla
                </h6>
                <h6 class="card-subtitle mb-2 text-muted">Treasurer</h6>
              </div>
            </div>
          </Col>
          <Col md={3} sm={12}>
            <div class="card">
              <img src={team5} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">Adv. Subhash Parmar</h6>
                <h6 class="card-subtitle mb-2 text-muted">Librarian</h6>
              </div>
            </div>
          </Col>
          <Col md={3} sm={12}>
            <div class="card">
              <img src={team9} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">Adv. Deepak Tyagi</h6>
                <h6 class="card-subtitle mb-2 text-muted">10+</h6>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={3} sm={12}>
            <div class="card">
              <img src={AradhnaChaturvedi} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">Adv. Aradhna Chaturvedi</h6>
                <h6 class="card-subtitle mb-2 text-muted">7+</h6>
              </div>
            </div>
          </Col>
          <Col md={3} sm={12}>
            <div class="card">
              <img src={AvishkarRawat} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">
                  Adv. Avishkar Singh Rawat
                </h6>
                <h6 class="card-subtitle mb-2 text-muted">5+</h6>
              </div>
            </div>
          </Col>

          <Col md={3} sm={12}>
            <div class="card">
              <img src={team8} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">Adv. Arti</h6>
                <h6 class="card-subtitle mb-2 text-muted">3+</h6>
              </div>
            </div>
          </Col>
          <Col md={3} sm={12}>
            <div class="card">
              <img src={RamanSharma} class="card-img-top" alt="..." />
              <div class="card-body text-center">
                <h6 class="card-title text-danger">Adv. Raman Sharma</h6>
                <h6 class="card-subtitle mb-2 text-muted">3+</h6>
              </div>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default ExecutiveBody;
